
import loadPolicies from 'bundle-loader?lazy&title=Policies!./components/routes/policies';
import loadRoles from 'bundle-loader?lazy&title=Roles!./components/routes/roles';
import loadPolicy from 'bundle-loader?lazy&title=Policy!./components/routes/policy';
import loadPeople from 'bundle-loader?lazy&title=People!./components/routes/people';
import loadRole from 'bundle-loader?lazy&title=Role!./components/routes/role';
import loadRolesV3 from 'bundle-loader?lazy&title=Roles!./components/routes/v3/roles';
import loadRoleV3 from 'bundle-loader?lazy&title=Role!./components/routes/v3/role';
import loadRolesMembershipV3 from 'bundle-loader?lazy&title=Role!./components/routes/v3/rolesMembership';
import loadRoleMembershipEditV3 from 'bundle-loader?lazy&title=Role!./components/routes/v3/roleMembership';
import loadCompanyView from 'bundle-loader?lazy&title=CompanyView!./components/routes/company-view';
import loadGroups from 'bundle-loader?lazy&title=Groups!./components/routes/groups';
import loadEditGroups from 'bundle-loader?lazy&title=Role!./components/routes/editGroups';
import loadAddGroup from 'bundle-loader?lazy&title=Role!./components/routes/addGroup';
import React from 'react';
import { actions } from './app-dux/company-dux';
import { clearState } from './app-dux/permissions-dux';
import { GOLD_COMPANY_ID } from './utils/constants';

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const routes = [
    {
        title: 'Groups',
        pattern: '/groups',
        sidebar: false,
        load: loadGroups
    },
    {
        title: 'Add Groups',
        pattern: '/group/add',
        sidebar: false,
        load: loadAddGroup
    },
    {
        title: 'Edit Group',
        pattern: '/group/:groupId',
        sidebar: false,
        load: loadEditGroups
    },
    {
        title: 'Policies',
        pattern: '/:companyId/policies',
        sidebar: true,
        load: loadPolicies
    },
    {
        title: 'Add Policy',
        pattern: '/:companyId/policy/add',
        sidebar: true,
        load: loadPolicy
    },
    {
        title: 'Edit Policy',
        pattern: '/:companyId/policy/edit/:policyId',
        sidebar: true,
        load: loadPolicy
    },
    {
        title: 'People Search',
        pattern: '/:companyId/people',
        sidebar: true,
        load: loadPeople
    },
    {
        title: 'Company View',
        pattern: '/:companyId/company-view',
        sidebar: true,
        load: loadCompanyView
    },
    //v2 role routes
    {
        title: 'Roles',
        pattern: '/:companyId/roles',
        sidebar: true,
        load: loadRoles
    },
    {
        title: 'Add Role',
        pattern: '/role/add',
        sidebar: true,
        load: loadRole
    },
    {
        title: 'Edit Role',
        pattern: '/role/:roleId',
        sidebar: true,
        load: loadRole
    },
    //v3 role routes
    {
        title: 'Roles',
        pattern: '/:companyId/v3/roles',
        sidebar: true,
        load: loadRolesV3
    },
    {
        title: 'Add Role',
        pattern: '/:companyId/v3/role/add',
        sidebar: true,
        load: loadRoleV3
    },
    {
        title: 'Edit Role',
        pattern: '/:companyId/v3/role/:roleId/edit',
        sidebar: true,
        load: loadRoleV3
    },
    {
        title: 'Role Membership',
        pattern: '/:companyId/v3/roles/membership',
        sidebar: true,
        load: loadRolesMembershipV3
    },
    {
        title: 'Edit Role Membership',
        pattern: '/:companyId/v3/role/membership/edit/:roleId',
        sidebar: true,
        load: loadRoleMembershipEditV3
    }
];

export const getMiddleware = ( store ) => {
    return [
        // Company
        ( action, nextRoute, prevRoute ) => {
            if ( nextRoute.state && nextRoute.state.params && nextRoute.state.params.companyId ) {
                if ( !nextRoute.state.params.companyId.includes( 'oidc' ) ) {
                    store.dispatch( actions.setCompany( nextRoute.state.params.companyId ) )
                    .then( () => {

                        action.ok();
                    } );
                } else {
                    action.ok();
                }
            } else if ( store.getState().permissions ) {
                store.dispatch( clearState( ) );
                action.ok();
            } else {
                action.ok();
            }
        },
        //redirect
        ( action, nextRoute, prevRoute ) => {
            if ( !nextRoute.match ) {
                let companyId = GOLD_COMPANY_ID;
                if ( nextRoute.state?.params?.companyId )  {
                    companyId = nextRoute.state?.params?.companyId;
                }
                action.redirect( `/${ companyId }/v3/roles` );
            } else {
                action.ok();
            }
        },
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            if ( nextRoute.match && !nextRoute.match.render &&
                typeof nextRoute.match.load === 'function' ) {

                nextRoute.match.load( ( asyncModule ) => {
                    nextRoute.match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};
